import { render, staticRenderFns } from "./List.vue?vue&type=template&id=2de234a1&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=2de234a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de234a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de234a1')) {
      api.createRecord('2de234a1', component.options)
    } else {
      api.reload('2de234a1', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=2de234a1&scoped=true&", function () {
      api.rerender('2de234a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckylogin/review/List.vue"
export default component.exports